module.exports = __webpack_public_path__ + "img/st-zagora.4f03ba9a.jpg";